module.exports = __webpack_public_path__ + "static/media/1022047.b7b3e363.jpg";